export default __webpack_public_path__ + "db8eebf3b24fbe62f565005e9736d216.jpg";